import { Box, Button, IconButton, Modal } from "@mui/material";
import { Typography } from "@mui/material";
import { TEXT_COLOR } from "../../theme";
import { shareModalStyles } from "./styles";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";

export const UpdateSubModal: React.FC<{
  open: boolean;
  handleCloseModal: () => void;
}> = ({ open, handleCloseModal }) => {
  const navigate = useNavigate();

  const handleClose = () => {
    handleCloseModal();
  };

  const handleNavigate = () => {
    navigate("/billing");
  };

  return (
    <Modal open={open ? open : false} onClose={handleClose}>
      <Box sx={shareModalStyles.updateSubContainer}>
        <Box
          sx={{
            ...shareModalStyles.mainContainer,
            maxWidth: "500px",
            width: "100%",
            borderRadius: "8px",
            boxShadow: 24,
          }}
        >
          <Box sx={shareModalStyles.topBarIconContainer}>
            <Box sx={{ mt: 1 }}>
              <Typography sx={shareModalStyles.title}>
                Update Subscription
              </Typography>
            </Box>
            <Box sx={shareModalStyles.closeIconContainer}>
              <IconButton onClick={handleClose}>
                <CloseIcon sx={{ fontSize: "30px" }} />
              </IconButton>
            </Box>
          </Box>
          <Typography sx={{ color: TEXT_COLOR, mt: 4 }}>
            Upgrade your account to OmMuse Minor or Major to use this feature.
            Click &quot;Update plan&quot; below to explore your options.
          </Typography>
          <Box sx={shareModalStyles.updatePlanContainer}>
            <Button
              sx={shareModalStyles.updatePlanButton}
              onClick={handleNavigate}
            >
              Update Plan
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};
